<template>
  <hr-text-field
    v-if="dataField.type === 'text'"
    :model-value="modelValue"
    :label="dataField.label"
    :multiline="dataField.allowMultiLines"
    :disable="offlineMode || disable"
    hide-bottom-space
    class="col-12"
    @update:model-value="updateModelValue"
  />

  <custom-select
    v-else-if="dataField.type === 'select'"
    :model-value="modalValueWithDefaults"
    :label="dataField.label"
    :options="getDataFieldOptions(dataField)"
    :multiple="dataField.allowMultipleOptions"
    :use-chips="dataField.allowMultipleOptions"
    :use-input="dataField.allowCustomOptions"
    :hint="dataField.allowCustomOptions ? $t('clients.modals.editClient.inputAddCustomOptionHint') : undefined"
    :disable="offlineMode || disable"
    new-value-mode="add-unique"
    outlined
    hide-bottom-space
    emit-value
    map-options
    class="col-12"
    @update:model-value="updateModelValue"
  />

  <date-input
    v-else-if="dataField.type === 'date'"
    :model-value="modelValue"
    :disable="offlineMode || disable"
    :label="dataField.label"
    outlined
    clearable
    class="col-12"
    @update:model-value="updateModelValue"
  />

  <div
    v-else-if="dataField.type === 'yesNo'"
    class="col-12"
  >
    <p
      :id="yesNoLabelId"
      class="hr-title-small q-mt-none q-mb-xs"
    >
      {{ dataField.label }}
    </p>
    <hr-option-group
      :model-value="modelValue"
      :aria-labelledby="yesNoLabelId"
      :options="[
        { label: $t('common.buttonYes'), value: true },
        { label: $t('common.buttonNo'), value: false }
      ]"
      :disable="offlineMode || disable"
      type="radio"
      inline
      @update:model-value="updateModelValue"
    />
  </div>

  <client-users-selector
    v-else-if="dataField.type === 'user'"
    :disable="offlineMode || disable"
    :model-value="modelValue"
    :label="dataField.label"
    class="col-12"
    :client="clientId"
    :readonly="!clientId"
    @update:model-value="updateModelValue"
  />
</template>

<script setup>
import { network as useNetworkStore } from 'src/store/network';
import { HrOptionGroup, HrTextField } from 'src/design-system';
import { computed, useId } from 'vue';

import CustomSelect from '../CustomSelect.vue';
import DateInput from '../DateInput.vue';
import ClientUsersSelector from '../UI/ClientUsersSelector.vue';

const networkStore = useNetworkStore();
const offlineMode = computed(() => networkStore.offlineMode);
const yesNoLabelId = useId();

const props = defineProps({
  modelValue: {
    type: [String, Boolean, Array, Object, Date, null],
    default: null,
    required: false,
  },
  dataField: {
    type: Object,
    required: true,
  },
  clientId: {
    type: String,
    required: false,
    default: '',
  },
  disable: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const updateModelValue = (value) => {
  emit('update:modelValue', value);
};

const getDataFieldOptions = (dataField) => {
  if (!Array.isArray(dataField.options)) {
    return [];
  }

  return dataField.options?.map((option) => ({
    label: option,
    value: option,
  }));
};

const modalValueWithDefaults = computed(() => {
  if (props.modelValue === undefined || props.modelValue === null) {
    if (props.dataField.type === 'select') {
      return props.dataField.allowMultipleOptions ? [] : '';
    }
    if (props.dataField.type === 'yesNo') {
      return null;
    }
    return null;
  }
  if (props.dataField.allowMultipleOptions && !Array.isArray(props.modelValue)) {
    if (props.modelValue) {
      return [props.modelValue];
    }

    return [];
  }
  return props.modelValue;
});

</script>
